import { Link } from "react-router-dom";

const FooterBottomBar = () => (
  <div style={{ backgroundColor: "var(--footer-surface)", borderTop: "1px solid var(--footer-border)" }}>
    <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row justify-between items-center gap-2">
      <span className="text-[12px]" style={{ color: "var(--footer-text-tertiary)" }}>
        © 2026 1 Wood Floors  All rights reserved
      </span>
      <div className="flex items-center gap-4 text-[12px]" style={{ color: "var(--footer-text-tertiary)" }}>
        <Link
          to="/privacy-policy"
          className="transition-colors duration-150"
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-tertiary)")}
        >
          Privacy Policy
        </Link>
        <span>·</span>
        <Link
          to="/terms-of-service"
          className="transition-colors duration-150"
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-tertiary)")}
        >
          Terms
        </Link>
        <span>·</span>
        <a
          href="/sitemap.xml"
          className="transition-colors duration-150"
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-tertiary)")}
        >
          Sitemap
        </a>
      </div>
    </div>
  </div>
);

export default FooterBottomBar;
